import { useSendOtpMutation } from '@/app/features/auth/auth.api';
import IMAGES from '@/assets/images';
import AuthLayout from '@/layouts/AuthLayout';
import { toast } from '@/lib/toast';
import { errorToast } from '@/utils';
import { Button, Flex, Form, Input } from 'antd';
import { useNavigate } from 'react-router';

export default function Login() {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [sendOtp, { isLoading }] = useSendOtpMutation();

  const handleSubmit = async (values: Record<string, unknown>) => {
    try {
      // await sendOtp({ ...values, product: "HRX", platform: "WEB" }).unwrap();
      await sendOtp({ ...values }).unwrap();
      toast('success', 'Otp send successfully');
      navigate(`/otp?email=${values?.email}`);
    } catch (err) {
      errorToast(err, 'OTP send fail, please try again');
    }
  };

  return (
    <AuthLayout
      leftContent={
        <div className="relative z-10 flex flex-col justify-center items-center mt-32">
          <div className="text-white text-2xl font-normal">Welcome to</div>

          <div className="flex items-center justify-center mt-4 w-56 h-32">
            <img
              src={IMAGES.mainLogo}
              alt="main_logo"
              className="w-56 h-32 object-contain"
            />
          </div>
        </div>
      }
    >
      <div className="flex flex-col justify-center items-center h-full">
        <div className="flex flex-col justify-center items-center mb-8 md:hidden">
          <div className="text-white text-2xl font-normal">Welcome to</div>

          <div className="flex items-center justify-center mt-4 w-56 h-32">
            <img
              src={IMAGES.mainLogo}
              alt="main_logo"
              className="w-56 h-32 object-contain"
            />
          </div>
        </div>
        <div className="justify-start text-white text-3xl font-bold mb-8">
          LOG IN
        </div>

        <Form
          form={form}
          size="large"
          layout="vertical"
          requiredMark="optional"
          className="custom-form w-80"
          onFinish={handleSubmit}
          // initialValues={{ email: 'cr7@gmail.com' }}
        >
          <Form.Item
            name="email"
            label={<span className="text-white">Email Address</span>}
            rules={[
              { required: true, message: 'Email is required' },
              {
                type: 'email',
                message: 'Please enter a valid email address',
              },
            ]}
          >
            <Input
              placeholder="Write here..."
              className="h-10 bg-transparent text-white"
            />
          </Form.Item>
          <Flex align="center" justify="center" gap={16} className="mt-6">
            <Button
              type="primary"
              className="w-full h-10 bg-teal-500 text-neutral-700 hover:!text-neutral-700 font-semibold"
              htmlType="submit"
              loading={isLoading}
            >
              Proceed To OTP
            </Button>
          </Flex>
        </Form>
      </div>
    </AuthLayout>
  );
}
